import { Injectable } from '@angular/core';

@Injectable()
export class DateUtil {
  /**
   * Convert yyyy-mm-dd to dd/mm/yyyy
   */
  dashesToSlashes(date: string): string {
    // Convert date to dd/mm/yyyy
    if (date != null) {
      const fields = date.split('-');
      return `${fields[2]}/${fields[1]}/${fields[0]}`;
    } else {
      return '';
    }
  }

  /**
   * Convert dd/mm/yyyy to yyyy-mm-dd
   */
  slashesToDashes(datepickerValue: string): string {
    // Convert dd/mm/yyyy to date
    if (datepickerValue) {
      const fields = datepickerValue.split('/');
      return `${fields[2]}-${fields[1]}-${fields[0]}`;
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/date.service.ts